import {makeAutoObservable} from 'mobx';

class DownloadFile {

	label;
	uri;
	selected;
	specsheet;

	constructor(label, uri, specsheet = '') {
		this.label = label;
		this.uri = uri;
		this.selected = false;
		this.specsheet = specsheet;
		makeAutoObservable(this);
	}

	toggleSelection(force = null) {
		this.selected = force === null ? !this.selected : force;
	}

}

export default DownloadFile;
